const API_URL = process.env.REACT_APP_BACKEND_URL;

// Token storage keys
const TOKEN_KEY = 'hiway_token';
const USER_KEY = 'hiway_user';

// Send OTP to phone number
export async function sendOTP(phone) {
  const response = await fetch(`${API_URL}/api/auth/send-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ phone }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to send OTP');
  }
  
  return response.json();
}

// Verify OTP and get token
export async function verifyOTP(phone, otp, name = null) {
  const response = await fetch(`${API_URL}/api/auth/verify-otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ phone, otp, name }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Invalid OTP');
  }
  
  const data = await response.json();
  
  // Store token and user
  localStorage.setItem(TOKEN_KEY, data.access_token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  
  return data;
}

// Get current user from API
export async function getCurrentUser() {
  const token = getToken();
  if (!token) return null;
  
  try {
    const response = await fetch(`${API_URL}/api/auth/me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      // Token invalid, clear storage
      logout();
      return null;
    }
    
    const user = await response.json();
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    return user;
  } catch (error) {
    console.error('Failed to get current user:', error);
    return null;
  }
}

// Update user profile
export async function updateProfile(updates) {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const response = await fetch(`${API_URL}/api/auth/me`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(updates),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update profile');
  }
  
  const user = await response.json();
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  return user;
}

// Get stored token
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// Get stored user
export function getStoredUser() {
  const userStr = localStorage.getItem(USER_KEY);
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
}

// Check if user is authenticated
export function isAuthenticated() {
  return !!getToken();
}

// Logout
export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

// Check user role
export function hasRole(requiredRole) {
  const user = getStoredUser();
  if (!user) return false;
  return user.role === requiredRole;
}

// Check if user is admin
export function isAdmin() {
  return hasRole('admin');
}

// Check if user is dhaba owner
export function isDhabaOwner() {
  return hasRole('dhaba_owner');
}

// Check if user is customer
export function isCustomer() {
  return hasRole('customer');
}
